import { SearchSelect } from '../SearchSelect';

// Per-supplier WHT default (INTENT only — no cert is issued here; §15 hard safety).
const WHT_INCOME_TYPES = [
  { value: 'SERVICE', label: 'ค่าบริการ (3%)' },
  { value: 'RENT', label: 'ค่าเช่า (5%)' },
  { value: 'TRANSPORT', label: 'ค่าขนส่ง (1%)' },
  { value: 'ADVERTISING', label: 'ค่าโฆษณา (2%)' },
  { value: 'PROFESSIONAL', label: 'ค่าวิชาชีพ (3%)' },
];

export function WhtDefaultFields({
  incomeType,
  rate,
  onChange,
}: {
  incomeType: string | null;
  rate: number | null;
  onChange: (next: { incomeType: string | null; rate: number | null }) => void;
}) {
  return (
    <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end' }}>
      <div style={{ minWidth: 220 }}>
        <label className="meta" style={{ display: 'block', marginBottom: 4 }}>
          ประเภทเงินได้ หัก ณ ที่จ่าย (ค่าตั้งต้น)
        </label>
        <SearchSelect
          value={incomeType ?? ''}
          onChange={(v) => onChange({ incomeType: v || null, rate })}
          options={WHT_INCOME_TYPES}
          getLabel={(v) => WHT_INCOME_TYPES.find((t) => t.value === v)?.label ?? v}
          placeholder="— ไม่หัก —"
        />
      </div>
      <div style={{ width: 120 }}>
        <label className="meta" style={{ display: 'block', marginBottom: 4 }}>
          อัตรา (%)
        </label>
        <input
          className="input"
          type="number"
          step="0.01"
          value={rate ?? ''}
          onChange={(e) =>
            onChange({ incomeType, rate: e.target.value === '' ? null : Number(e.target.value) })
          }
        />
      </div>
    </div>
  );
}
